import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import { css } from 'styled-components';
export const withColors = _ref => {
  let {
    color
  } = _ref;
  if (!color) return css(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: var(", ");\n  "])), color);
};